export default "__VITE_ASSET__PQw4uxXK__"